import styled from 'styled-components';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
} from 'styled-system';

export interface BoxProps
  extends SpaceProps,
    LayoutProps,
    FlexboxProps,
    PositionProps,
    BackgroundProps,
    BorderProps,
    ShadowProps,
    ColorProps,
    GridProps {
  as?: React.ElementType;
  className?: string;
  children?: React.ReactNode;
  ref?: React.Ref<HTMLElement>;
}

const Box = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop),
})<BoxProps>`
  ${background}
  ${border}
  ${color}
  ${flexbox}
  ${grid}
  ${layout}
  ${position}
  ${shadow}
  ${space}
`;

export default Box;
